import "../../resources/scss/board-loading.scss"

const BoardLoading = ({
                          title = "데이터를 불러오는 중...",
                          subtitle = null,
                          showSpinner = true,
                          size = "medium", // small, medium, large
                      }) => {
    return (
        <div className={`board-loading ${size}`}>
            <div className="loading-content">
                {showSpinner && (
                    <div className="loading-spinner">
                        <div className="spinner-ring">
                            <div></div>
                            <div></div>
                            <div></div>
                            <div></div>
                        </div>
                    </div>
                )}
                <div className="loading-text">
                    <h3 className="loading-title">{title}</h3>
                    {subtitle && <p className="loading-subtitle">{subtitle}</p>}
                </div>
            </div>
        </div>
    )
}

export default BoardLoading
